import FormValidable from './FormValidable'

export default class FormControl extends FormValidable {
  constructor(options = {}) {
    super(options)
    this.value = options.value
    this.form = options.form
    this.name = options.name
    this.default = options.default
    this.touched = false

    this.validate()
  }

  reset () {
    this.setValue(this.default)
  }

  async setValue (value) {
    if (this.value !== value) {
      this.value = value
      await this.validate()
    }
  }
}
